{
	"textures": [
		{
			"image": "candle",
			"format": "RGBA8888",
			"size": {
				"w": 887,
				"h": 209
			},
			"scale": 1,
			"frames": [
				{
					"filename": "candle/candle00",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 281,
						"h": 248
					},
					"spriteSourceSize": {
						"x": 67,
						"y": 17,
						"w": 91,
						"h": 147
					},
					"frame": {
						"x": 0,
						"y": 0,
						"w": 91,
						"h": 147
					}
				},
				{
					"filename": "candle/candle01",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 281,
						"h": 248
					},
					"spriteSourceSize": {
						"x": 55,
						"y": 17,
						"w": 132,
						"h": 147
					},
					"frame": {
						"x": 91,
						"y": 0,
						"w": 132,
						"h": 147
					}
				},
				{
					"filename": "candle/candle02",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 281,
						"h": 248
					},
					"spriteSourceSize": {
						"x": 56,
						"y": 17,
						"w": 177,
						"h": 164
					},
					"frame": {
						"x": 223,
						"y": 0,
						"w": 177,
						"h": 164
					}
				},
				{
					"filename": "candle/candle03",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 281,
						"h": 248
					},
					"spriteSourceSize": {
						"x": 24,
						"y": 17,
						"w": 244,
						"h": 164
					},
					"frame": {
						"x": 400,
						"y": 0,
						"w": 244,
						"h": 164
					}
				},
				{
					"filename": "candle/candle04",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 281,
						"h": 248
					},
					"spriteSourceSize": {
						"x": 25,
						"y": 19,
						"w": 243,
						"h": 209
					},
					"frame": {
						"x": 644,
						"y": 0,
						"w": 243,
						"h": 209
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
}